import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import * as AppRouting from './feature.routing';
import { HomeComponent } from '@app/features/home/home.component';
import { SampleComponent } from '@app/features/sample/sample.component';
import { JourneyComponent } from '@app/features/journey.component';
import { ProfileComponent } from '@app/features/profile/profile.component';
import { ShareModule } from '@app/shared/shared.module';
import { SaveComponent } from '@app/features/save/save.component';

import { QuestionService } from '@app/core/question.service';
import { QuestionControlService } from '@app/core/question-control.service';
import { KycService } from '@app/core/kyc.service';
import { SingpassService } from '@app/core/singpass.service';

import { MyFinancialComponent } from './my-financial/my-financial.component';
import { CoverageComponent } from '@app/features/coverage/coverage.component';
import { NewPolicyComponent } from '@app/features/coverage/new-policy/new-policy.component';
import { PolicyDetailsComponent } from '@app/features/coverage/policy-details/policy-details.component';
import { MyLifestyleComponent } from '@app/features/my-lifestyle/my-lifestyle.component';
import { MyNeedsComponent } from '@app/features/my-needs/needs.component';
import { MyFinancialModule } from './my-financial/my-financial.module';
import { NavTabService } from '@app/core/navTab.service';
import {
  ProfileRouteGuard,
  MyFinancialRouteGuard,
  CoverageRouteGuard,
  SaveRouteGuard,
  EmailRequiredGuard,
  ReferralCodeGuard,
  NeedsRouteGuard
} from '@app/shared/common/route-guard';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { MyDatePickerModule } from 'mydatepicker';
import { ToastrModule } from 'ngx-toastr';
import { MatDialogModule } from '@angular/material/dialog';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { Error404Component } from './error404/error404.component';

@NgModule({
  declarations: [
    HomeComponent,
    SampleComponent,
    JourneyComponent,
    ProfileComponent,
    CoverageComponent,
    NewPolicyComponent,
    PolicyDetailsComponent,
    MyFinancialComponent,
    SaveComponent,
    ThankYouComponent,
    MyLifestyleComponent,
    Error404Component,
    MyNeedsComponent
  ],
  exports: [MatDialogModule],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ShareModule,
    MyFinancialModule,
    MyDatePickerModule,
    RouterModule.forChild(AppRouting.routes),
    ToastrModule.forRoot(),
    Ng2TelInputModule
  ],
  providers: [
    QuestionService,
    QuestionControlService,
    NavTabService,
    KycService,
    SingpassService,
    ProfileRouteGuard,
    CoverageRouteGuard,
    MyFinancialRouteGuard,
    SaveRouteGuard,
    EmailRequiredGuard,
    ReferralCodeGuard,
    NeedsRouteGuard
  ]
})
export class FeatureModule {}



// WEBPACK FOOTER //
// ./src/app/features/feature.module.ts